/*
* @Author: Mark Miller
* @Date:   2018-08-29 23:18:31
* @Last Modified by:   msmiller
* @Last Modified time: 2019-12-15 14:29:22
*
* Copyright (c) 2017-2018 Sharp Stone Codewerks / Mark S. Miller
*
*
* Assumptions:
* - Scrolling page is $('#activity_scroller')
* - Display content in $('#activity_table tbody')
*/



import { Controller } from "stimulus"

export default class extends Controller {

    connect() {
      if (this.data.has("refreshInterval")) {
        $('select.dropdown').dropdown();
        // console.log("-=> timeline_controller refreshing started");
        this.startRefreshing();
      }

      // console.log("-=> timeline_controller connected");
    }

    disconnect() {
      this.stopRefreshing();
    }

    initialize_feed() {

      $.get("/" + this.data.get("kontroller") + "/json_offsets/0/0/0" + this.data.get("url_paramz"), function(json) {
        console.log("offsets => " + json.last + ", " + json.first + ", " + json.length);
        document.cookie="activity_head=" + json.last;
      }).then(json => {
        this.data.set("lastPoz", json.last);
        this.data.set("firstPoz", json.first);
        this.data.set("numRecords", json.length);
      }
      );

      //$('#activity_table tbody').load( "/<%= kontroller %>/ajax_index/0/0" + url_paramz );
      $.ajax({
        url: "/" + this.data.get("kontroller") + "/ajax_index/0/0" + this.data.get("url_paramz"),
        success: function (data) {
          $('#activity_table tbody').html(data);
          $("time.timeago").timeago();
        }
      });

    }

    initialize() {
        // console.log("-=> timeline_controller initialize ");

      jQuery.timeago.settings.strings["en"] = {
        prefixAgo: null,
        prefixFromNow: null,
        suffixAgo: "",
        suffixFromNow: "",
        seconds: "<1m",
        minute: "1m",
        minutes: "%dm",
        hour: "1h",
        hours: "%dh",
        day: "1d",
        days: "%dd",
        month: "1mo",
        months: "%dmo",
        year: "1yr",
        years: "%dyr",
        wordSeparator: " ",
        numbers: []
      };



      if (this.data.has("kontroller")) {
        // console.log("-=> timeline_controller initializing state");

        this.data.set("lastPoz", 0);
        this.data.set("firstPoz", 0);
        this.data.set("numRecords", 0);

        this.initialize_feed();
//console.log("Initialize done:");
//console.log(this.data.get("lastPoz"));
//console.log(this.data.get("firstPoz"));
//console.log(this.data.get("numRecords"));
//console.log(this.data.get("url_paramz"));

      }
    }

    /* ---- filters ---- */

    selector_to_url(suffix, id) {
      var filter_suffix = event.currentTarget.getAttribute('data-timeline-suffix');
      var filter_id = event.currentTarget.value;
      if (id == 0)  {
        window.location='/activities/';
      } else {
        window.location='/activities/' + filter_suffix + '/' + filter_id;
      }
    }


    /* ---- poller ---- */

    load_new_activities() {
      fetch('/ping/num_new_activities')
        .then(response => response.text())
        .then(html => {
          var num_new_activities = html
          if (num_new_activities > 0) {
              $('#load_more_activities').removeClass('disabled');
              $('#load_more_activities').text('LOAD NEW (' + num_new_activities + ')');
              $("time.timeago").timeago();
           }
        })
    }

    startRefreshing() {
      this.timelineTimer = setInterval(() => {
        this.load_new_activities()
      }, this.data.get("refreshInterval"))
    }

    stopRefreshing() {
        if (this.timelineTimer) {
          clearInterval(this.timelineTimer)
        }
      }
    /* ---- loader ---- */

    load_new_events() {

      // // console.log("-=> timeline_controller load_new_events");
      // console.log(this.data);
      // console.log(this.data.get("lastPoz"));
      // console.log(this.data.get("firstPoz"));
      // console.log(this.data.get("numRecords"));
      // console.log(this.data.get("url_paramz"));
      // console.log("STATE: " + this.data.get("lastPoz") + " / " + this.data.get("numRecords"));

      var cdata = this.data;

      $.ajax({
          url: "/" + this.data.get("kontroller") + "/json_offsets/0/" + this.data.get("lastPoz") + "/" + this.data.get("numRecords") + this.data.get("url_paramz"),
          type: "GET",
          dataType: "json",
          success: function(json) {
              // console.log("acting on new data => " + json.last + ", " + json.first + ", " + json.length);
              if (json.length > 0) {
                $.ajax({
                  url: "/" + cdata.get("kontroller") + "/ajax_index/0/" + json.length + cdata.get("url_paramz"),
                  success: function (data) {
                      //$("#activity_table tbody").prepend(data);
                      $(data).hide().prependTo("#activity_table tbody").fadeIn(1000);
                      cdata.set("lastPoz", json.last);
                      document.cookie="activity_head=" + json.last;
                      $('#load_more_activities').addClass('disabled');
                      $('#load_more_activities').text('LOAD NEW');
                      $("time.timeago").timeago();
                 }
                });
              }
          },
      })
    }

    /* ----- scroll handler ---- */

    load_scroll_events() {

      // // console.log("-=> timeline_controller load_scroll_events");
      // console.log(this.data);
      // console.log(this.data.get("lastPoz"));
      // console.log(this.data.get("firstPoz"));
      // console.log(this.data.get("numRecords"));
      // console.log(this.data.get("url_paramz"));
      // console.log("STATE: " + this.data.get("lastPoz") + " / " + this.data.get("numRecords"));

      var cdata = this.data;
      var old_first = this.data.get("firstPoz");
      var old_numrec = this.data.get("numRecords");

      $.ajax({
          url: "/" + this.data.get("kontroller") + "/json_offsets/" + this.data.get("firstPoz") + "/0/" + this.data.get("numRecords") + this.data.get("url_paramz"),
          type: "GET",
          dataType: "json",
          success: function(json) {
              if (json.length > 0) {

        lastPoz = json.last;
        document.cookie="activity_head=" + lastPoz;
        firstPoz = json.first;
        numRecords = json.length;

                $.ajax({
                  url: "/" + cdata.get("kontroller") + "/ajax_index/" + old_numrec + "/" + (numRecords - old_numrec) + cdata.get("url_paramz"),
                  success: function (data) {
                      //$("#activity_table tbody").prepend(data);
                      $(data).hide().appendTo("#activity_table tbody").fadeIn(1000);
                      cdata.set("lastPoz", json.last);
                      document.cookie="activity_head=" + json.last;
                      $('#load_more_activities').addClass('disabled');
                      $('#load_more_activities').text('LOAD NEW');
                      $("time.timeago").timeago();
                 }
                });
              }
          },
      })
    }

  should_scroll() {
    var elem = $('#activity_scroller');         
    if ((elem.scrollTop() > 0) && ((elem[0].scrollHeight - elem.scrollTop() - elem.outerHeight()) < 1)) {
      return(true);
    } else {
      return(false);
    }
  }

    activity_scroller() {
      //// console.log("-=> timeline_controller activity_scroller");
      if (should_scroll()) {
        //console.log("SCROLL!!!!");

      var cdata = this.data;
      var old_first = this.data.get("firstPoz");
      var old_numrec = this.data.get("numRecords");

      $.ajax({
          url: "/" + this.data.get("kontroller") + "/json_offsets/" + this.data.get("firstPoz") + "/0/" + this.data.get("numRecords") + this.data.get("url_paramz"),
          type: "GET",
          dataType: "json",
          success: function(json) {
              if (json.length > 0) {

        var lastPoz = json.last;
        document.cookie="activity_head=" + lastPoz;
        var firstPoz = json.first;
        var numRecords = json.length;

                $.ajax({
                  url: "/" + cdata.get("kontroller") + "/ajax_index/" + old_numrec + "/" + (numRecords - old_numrec) + cdata.get("url_paramz"),
                  success: function (data) {
                      //$("#activity_table tbody").prepend(data);
                      $(data).hide().appendTo("#activity_table tbody").fadeIn(1000);
                      cdata.set("lastPoz", json.last);
                      document.cookie="activity_head=" + json.last;
                      $('#load_more_activities').addClass('disabled');
                      $('#load_more_activities').text('LOAD NEW');
                      $("time.timeago").timeago();
                 }
                });
              }
          },
      })


      }
    }


  };

// console.log("-=> timeline_controller loaded");
